export const enum VARIANTS {
  CRITICAL = 'critical',
  PRIMARY = 'primary',
  TERTIARY = 'tertiary',
  SECONDARY = 'secondary',
  SYMBOL = 'symbol',
}
